var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomPlanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.625V3.375C10.5 2.02 8.21062 0.875 5.5 0.875C2.78938 0.875 0.5 2.02 0.5 3.375V9.625C0.5 10.98 2.78938 12.125 5.5 12.125C8.21062 12.125 10.5 10.98 10.5 9.625ZM5.5 2.125C7.80688 2.125 9.20687 3.06687 9.25 3.37125C9.20687 3.68313 7.80688 4.625 5.5 4.625C3.19313 4.625 1.79313 3.68313 1.75 3.37875C1.79313 3.06687 3.19313 2.125 5.5 2.125ZM1.75 5.00438C2.67438 5.53375 4.02313 5.875 5.5 5.875C6.97687 5.875 8.32562 5.53375 9.25 5.00438V6.49625C9.20687 6.80813 7.80688 7.75 5.5 7.75C3.19313 7.75 1.79313 6.80813 1.75 6.5V5.00438ZM1.75 9.625V8.12938C2.67438 8.65875 4.02313 9 5.5 9C6.97687 9 8.32562 8.65875 9.25 8.12938V9.62125C9.20687 9.93312 7.80688 10.875 5.5 10.875C3.19313 10.875 1.79313 9.93312 1.75 9.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomPlanIcon);
export default __webpack_public_path__ + "static/media/CustomPlanIcon.ef62a78b16f03e3aeb999cd186738305.svg";
export { ForwardRef as ReactComponent };